import React, { Component } from 'react';
import * as S from './PageError.styled.js';

interface Props {
  title: string;
  text: string;
  visible: boolean;
}

interface State {
  isVisible: boolean;
}

class PageError extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isVisible: false };
  }

  componentDidMount() {
    if (this.props.visible) {
      this.setState({ isVisible: this.props.visible });
    }
  }

  componentDidUpdate(props) {
    if (this.props.visible !== props.visible) {
      this.setState({ isVisible: this.props.visible });
    }
  }

  render() {
    const { isVisible } = this.state;
    return (
      <S.PageError $slideDown={isVisible}>
        <S.PageErrorInnerContainer>
          <S.PageErrorHeader>{this.props.title}</S.PageErrorHeader>
          <S.PageErrorMessage>{this.props.text}</S.PageErrorMessage>
        </S.PageErrorInnerContainer>
      </S.PageError>
    );
  }
}

// Props validated via TypeScript `Props` interface above

export default PageError;
